import * as React from "react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

/**
 * App-wide toast surface. shadcn's stock sonner reads `next-themes`; we drive
 * theming with `data-theme` on <html> instead, so this wrapper observes that
 * attribute and forwards it to Sonner. Styling is pinned to the Daylight
 * Wayfinder tokens via CSS variables so toasts match either surface.
 */
function useDocumentTheme(): "light" | "dark" {
  const get = () =>
    document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light";
  const [theme, setTheme] = React.useState<"light" | "dark">(get);

  React.useEffect(() => {
    const obs = new MutationObserver(() => setTheme(get()));
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    return () => obs.disconnect();
  }, []);

  return theme;
}

export function Toaster(props: ToasterProps) {
  const theme = useDocumentTheme();
  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="bottom-center"
      style={
        {
          "--normal-bg": "var(--surface)",
          "--normal-text": "var(--fg)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
}
